var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicesImg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    fill: "#B09A68",
    d: "M60,61.063c0-0.553,0.447-1,1-1s1,0.447,1,1s-0.447,1-1,1S60,61.615,60,61.063z M54,61.063 c0-0.553,0.447-1,1-1s1,0.447,1,1s-0.447,1-1,1S54,61.615,54,61.063z M6,61.063c0-0.553,0.448-1,1-1s1,0.447,1,1s-0.448,1-1,1 S6,61.615,6,61.063z M0,61.063c0-0.553,0.448-1,1-1s1,0.447,1,1s-0.448,1-1,1S0,61.615,0,61.063z M60,55.063c0-0.553,0.447-1,1-1 s1,0.447,1,1s-0.447,1-1,1S60,55.615,60,55.063z M0,55.063c0-0.553,0.448-1,1-1s1,0.447,1,1s-0.448,1-1,1S0,55.615,0,55.063z  M60,7.063c0-0.552,0.447-1,1-1s1,0.448,1,1s-0.447,1-1,1S60,7.615,60,7.063z M0,7.063c0-0.552,0.448-1,1-1s1,0.448,1,1 s-0.448,1-1,1S0,7.615,0,7.063z M60,1.063c0-0.552,0.447-1,1-1s1,0.448,1,1s-0.447,1-1,1S60,1.615,60,1.063z M54,1.063 c0-0.552,0.447-1,1-1s1,0.448,1,1s-0.447,1-1,1S54,1.615,54,1.063z M6,1.063c0-0.552,0.448-1,1-1s1,0.448,1,1s-0.448,1-1,1 S6,1.615,6,1.063z M0,1.063c0-0.552,0.448-1,1-1s1,0.448,1,1s-0.448,1-1,1S0,1.615,0,1.063z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    fill: "#303034",
    d: "M13,40.063h17.5v1.5c0,0.275,0.224,0.5,0.5,0.5s0.5-0.225,0.5-0.5v-1.5H49 c0.828,0,1.5-0.672,1.5-1.5v-22c0-0.829-0.672-1.5-1.5-1.5H13c-0.829,0-1.5,0.671-1.5,1.5v22C11.5,39.391,12.171,40.063,13,40.063z  M12.5,16.562c0-0.276,0.224-0.5,0.5-0.5h36c0.276,0,0.5,0.224,0.5,0.5v22c0,0.275-0.224,0.5-0.5,0.5H13 c-0.276,0-0.5-0.225-0.5-0.5V16.562z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    fill: "#303034",
    d: "M15,37.063h32c0.276,0,0.5-0.225,0.5-0.5v-18c0-0.276-0.224-0.5-0.5-0.5H15 c-0.276,0-0.5,0.224-0.5,0.5v18C14.5,36.838,14.724,37.063,15,37.063z M15.5,19.062h31v17h-31V19.062z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    fill: "#303034",
    d: "M25.5,43.063c-1.08-0.025-1.976,0.83-2,1.91c0,0.029,0,0.061,0,0.09v1.5 c0,0.275,0.224,0.5,0.5,0.5h14c0.276,0,0.5-0.225,0.5-0.5v-1.426c0.032-1.113-0.845-2.041-1.958-2.074c-0.015,0-0.028,0-0.042,0 H25.5z M37.5,45.137v0.926h-13v-1c-0.024-0.527,0.384-0.977,0.912-1c0.029-0.002,0.059-0.002,0.088,0h11 c0.562,0.008,1.01,0.471,1.002,1.031C37.502,45.109,37.501,45.123,37.5,45.137z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesImg4);
export default __webpack_public_path__ + "static/media/services_img_4.c4c4a3c1d29dc9b62ae991c422b53011.svg";
export { ForwardRef as ReactComponent };